export * from './alert.component';


// WEBPACK FOOTER //
// ./public/app/_directives/index.ts